export default __webpack_public_path__ + "static/media/Blue Bull.befbe816.jpg";